import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { DesktopFooterWrapper, MobileFooterWrapper } from '../styles'
import { FC } from 'react'
import { FLOWCODE_ROOT } from '@dtx-company/true-common/src/constants/root'
import { FooterLink } from '../FooterLink'
import { Spacer } from '@dtx-company/shared-components/src/components/atoms/Spacer/index'
import { Text } from '@dtx-company/shared-components/src/components/atoms/Text/index'
import { UnauthSlot } from '@dtx-company/flow-codegen/src/page/typeUtils'
import { desktopFooterData } from './footer-data/desktop'
import { mobileFooterData } from './footer-data/mobile'

const TermsAndService: FC = () => (
  <Box justifyContent={'center'} alignItems="center" width="100%" gridArea="trademark">
    <Text fontSize={'10px'} color="primary.white">
      Flowcode is a trademark of the dtx company&nbsp;|&nbsp; &copy;&nbsp;
      {`${new Date().getFullYear()} the dtx company`}
    </Text>
  </Box>
)
export const MinimalMobileFooter: FC<{ flowpageUrl?: string }> = ({ flowpageUrl }) => {
  return (
    <MobileFooterWrapper role="contentinfo" padding="4px">
      <Box margin="0px" width="100%" padding="0px 8px" justifyContent="center">
        {mobileFooterData(flowpageUrl).map((section, index) => (
          <Box
            key={`section-${index}`}
            alignItems={index === 0 ? 'flex-end' : 'flex-start'}
            justifyContent="flex-start"
            flexDirection="column"
            gridGap="8px"
            mr={index === 0 ? 3 : 0}
            ml={index === 0 ? 0 : 3}
            flex="1"
            maxWidth="50%"
          >
            {section.map(link => (
              <FooterLink key={link.href} {...link}>
                <Text variant="body/small" color="white">
                  {link.label}
                </Text>
              </FooterLink>
            ))}
          </Box>
        ))}
      </Box>
      <TermsAndService />
    </MobileFooterWrapper>
  )
}

export const MinimalDesktopFooter: FC<{ flowpageUrl?: string }> = ({ flowpageUrl }) => {
  return (
    <DesktopFooterWrapper role="contentinfo">
      <Box alignItems="center" width="100%" justifyContent="center">
        {desktopFooterData(flowpageUrl).map(link => (
          <FooterLink key={link.href} {...link}>
            <Text variant="body/small" color="white">
              {link.label}
            </Text>
          </FooterLink>
        ))}
      </Box>
      <TermsAndService />
    </DesktopFooterWrapper>
  )
}

export const CustomFooter: FC<{
  customFooter: UnauthSlot
}> = ({ customFooter }) => {
  const privacyPolicyUrl = customFooter?.data?.privacyPolicyUrl
  const termsOfServiceUrl = customFooter?.data?.termsOfServiceUrl
  return (
    <Box
      role="contentinfo"
      zIndex={9}
      flexDirection="column"
      padding="12px"
      justifyContent="center"
      height="40px"
      bg="primary.black"
      gridArea="footer"
      alignItems="center"
      width="100%"
    >
      <Box>
        {privacyPolicyUrl && (
          <FooterLink href={privacyPolicyUrl}>
            <Text variant="body/small" color="white">
              Privacy Policy
            </Text>
          </FooterLink>
        )}
        {privacyPolicyUrl && termsOfServiceUrl && <Spacer mr="16px" />}
        {termsOfServiceUrl && (
          <FooterLink href={termsOfServiceUrl}>
            <Text variant="body/small" color="white">
              Terms of Use
            </Text>
          </FooterLink>
        )}
      </Box>
    </Box>
  )
}

export const MinimalFooter: FC<{ route?: string }> = ({ route }) => {
  const flowpageUrl = route ? FLOWCODE_ROOT + route : undefined
  return (
    <>
      <MinimalMobileFooter flowpageUrl={flowpageUrl} />
      <MinimalDesktopFooter flowpageUrl={flowpageUrl} />
    </>
  )
}
